import { createRoot, hydrateRoot } from "react-dom/client";
import App, { preloadRoute } from "./App";
import { initAnalytics } from "./lib/analytics";
import "./index.css";

initAnalytics();

// Fetch the current route's chunk before hydrating, so the first client
// render matches the prerendered HTML (scripts/prerender.mjs) exactly and
// React adopts the existing DOM instead of replacing it.
//
// The dev server (and any URL that isn't prerendered) serves index.html with
// an empty #root, so there is nothing to hydrate; render from scratch there,
// otherwise React reports a hydration mismatch.
preloadRoute(window.location.pathname).then(() => {
  const root = document.getElementById("root")!;
  if (root.hasChildNodes()) {
    hydrateRoot(root, <App />);
  } else {
    createRoot(root).render(<App />);
  }
});
